import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'api.'

@vsingleton()
export class ExportRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'v1.'

  checkExportStatus(exportExcel) {
    return this.ziggyRoute('check_export_status', { exportExcel: exportExcel })
  }
}